export const scheduleQueryKeys = {
  all: ['scheduled'] as const,
  tab: () => [...scheduleQueryKeys.all, 'tab'] as const,
  list: (storeIds: number[]) =>
    [...scheduleQueryKeys.all, 'list', storeIds] as const,
  detail: (orderId: number) =>
    [...scheduleQueryKeys.all, 'detail', orderId] as const,
};
